import { render, staticRenderFns } from "./GerenciamentoServico.vue?vue&type=template&id=87e1edd0"
import script from "./GerenciamentoServico.vue?vue&type=script&lang=js"
export * from "./GerenciamentoServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports